export const addFunctionModal = {
  extend: 'ModalWindow',
  props: {
    width: '100%',
    maxWidth: 'I3'
  },
  tag: 'form',
  state: {
    key: '',
    title: '',
    type: 'functions',
    value: () => {
      // Do nothing
    }
  },
  ModalHeader: {
    title: 'Add a new function'
  },
  Flex: {
    overflow: 'auto',
    padding: 'A C3 0',
    minHeight: 'G3',
    minWidth: '100%',
    flow: 'column',
    flexAlign: 'flex-start space-between',
    gap: 'C1',
    'Flex.info': {
      flow: 'column',
      gap: 'B3',
      width: '50%',
      // The shared field kit (components/AppField.js): the caption label
      // above the control, the brand `field` fill with the hairline edge.
      // edit-function-modal.js extends this page and overrides both fields
      // BY KEY (`'AppField.title': {}`, and `'AppField.key'` with a disabled
      // `AppInput`), so the two pages move together.
      'AppField.title': {
        label: (el) => el.call('polyglot', 'editor.addFunction.title'),
        AppInput: {
          value: '{{ title }}',
          required: true,
          placeholder: (el) => el.call('polyglot', 'editor.addFunction.titlePlaceholder'),
          onKeyup: (e, el, s) => {
            const val = el.node.value
            const obj = {
              title: val
            }
            const canApplyKey = !s.touched && window.location.pathname.includes('/add-function')
            if (canApplyKey) {
              obj.key = el.call('toCamelCase', val.toLowerCase()).replace(/[^a-zA-Z]/gu, '')
            }
            s.update(obj)
          }
        }
      },
      'AppField.key': {
        label: (el) => el.call('polyglot', 'editor.addComponent.key'),
        AppInput: {
          value: '{{ key }}',
          required: true,
          placeholder: 'fetchExample',
          onKeydown: (e, el) => {
            const val = el.node.value
            const NOT_ALLOWED = ['&', '*', '-', ':', '@', '.', '/', '!', ' ']
            const preventChars = el.call('stringIncludesAny', val, NOT_ALLOWED)
            if (preventChars) {
              e.preventDefault()
            }
          },
          onKeyup: (e, el, s) => {
            const val = el.node.value
            s.update({
              touched: true,
              key: val.replace(/[^a-zA-Z]/gu, '')
            })
          }
        }
      }
    },
    'Group.code': {
      minWidth: '100%',
      Title: {
        text: '{{ editor.addFunction.code | polyglot }}'
      },
      CodePreviewWidget: {
        props: (el, s) => ({
          minWidth: '100%',
          widthRange: null,
          theme: 'field-static',
          round: 'X2',
          padding: 'X2 X2 X2 -',
          minHeight: 'G1',
          Monaco: {
            foldLevel: false,
            opacity: 1,
            fileTab: {
              code: el.call('stringifyCode', s.value),
              type: 'javascript',
              filename: 'function.js',
              fileTabKey: 'function'
            },
            onCodeEditCallback: async (editor) => {
              s.quietReplace({
                value: await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ editor.getValue())
              })
            }
          }
        })
      }
    },
    'Button.showAdvanced': {
      margin: '- -Z2',
      gap: 'X',
      background: 'transparent',
      borderWidth: 'hairline',
      borderStyle: 'solid',
      theme: 'common-card-outline-interactive',
      icon: (el, s) => `arrow angle ${s.advanced ? 'up' : 'down'}`,
      text: (el, s) =>
        el.call('polyglot', s.advanced ? 'editor.advanced.hide' : 'editor.advanced.show'),
      onClick: (ev, el, s) =>
        s.update({
          advanced: !s.advanced
        })
    },
    'Flex.advanced': {
      hide: ({ state }) => !state.advanced,
      flow: 'column',
      align: 'flex-start space-between',
      gap: 'C1',
      width: '100%',
      // The shared field kit (components/AppField.js): the caption label
      // above the control, the brand `field` fill with the hairline edge.
      'AppField.description': {
        width: '100%',
        label: (el) => el.call('polyglot', 'editor.addComponent.description'),
        AppTextarea: {
          value: (el, s) => s[el.key.split('.')[1]],
          placeholder: (el) => el.call('polyglot', 'editor.addFunction.descriptionPlaceholder'),
          onKeyup: (e, el, s) => {
            s.update({
              description: el.node.value
            })
          }
        }
      }
    }
  },
  ModalFooter: {
    CheckButton: {
      type: 'submit',
      reverse: true,
      icon: 'arrow right',
      text: '{{ common.action.next | polyglot }}'
    }
  },
  onSubmit: async (e, el, s) => {
    e.preventDefault()
    const exists = el.getFunctions(s.key)

    try {
      if (s.value) {
        try {
          const res = exists
            ? await el.call('updateItem', s.type, s.key, s)
            : await el.call('createItem', s.type, s.key)

          if (res?.success) {
            await el.call('closeRouterModal')
          } else {
            el.call('openNotification', {
              title: el.call('polyglot', 'editor.addComponent.error.title'),
              message: el
                .call('polyglot', 'editor.addFunction.createFailed')
                .replace('{key}', s.key),
              type: 'error'
            })
          }
        } catch (err) {
          console.log(`in addFunctionModal catch`, err.message)
          el.call('openNotification', {
            title: el.call('polyglot', 'editor.addComponent.error.title'),
            message: el.call('polyglot', 'editor.addFunction.createFailed').replace('{key}', s.key),
            type: 'error'
          })
        }
      }
    } catch (err) {
      console.log(`in addFunctionModal catch`, err.message)
      el.call('openNotification', {
        title: el.call('polyglot', 'editor.addComponent.error.title'),
        message: el.call('polyglot', 'editor.addFunction.codeError'),
        type: 'error'
      })
    }
  }
}
